<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardHeader>Style/Color Import Matching</CCardHeader>
      <CCardBody>
        <form @submit.prevent="submit()">
          <vue-dropzone v-if="dropzoneOptions.url" @vdropzone-error="errorUpload" @vdropzone-success="successUpload" ref="myVueDropzone" id="dropzone" :useCustomSlot="true" :options="dropzoneOptions">
            <div class="dropzone-custom-content">
              <h4 class="dropzone-custom-title">Drag and drop file</h4>
              <div class="subtitle">....or click to select a image(s) from your computer</div>
            </div>
          </vue-dropzone>
        </form>
        <!-- <input id="dealCsv" type="file" /> -->
        <!-- <small-loader v-if="loading"></small-loader> -->
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
var methods = {}

methods.submit = function (res) {
  // this.loading = true
  // const postData = {
  //   data: JSON.stringify(res)
  // }
  // console.log(postData)
  // axios.post(this.$apiAdress + '/api/uploadStyleColors?token=' + localStorage.getItem('api_token'), postData).then(response => {
  //   console.log(response)
  //   this.loading = false
  // }).catch(e => {
  //   console.log(e)
  // })
}

methods.errorUpload = function (e, a) {
  console.log(a)
}

methods.successUpload = function (e, a) {
  console.log(a)
}

methods.getParsecsvdata = function (data) {
  // var data = this.csvData
  var parsedata = [];
  var newLinebrk = data.split("\n");
  for(var i = 0; i < newLinebrk.length; i++) {

      parsedata.push(newLinebrk[i].split(","))
  }
  this.submit(parsedata)
  // return parsedata
}

methods.get = function (data) {
  
}

export default {
    // ===Component name
    name: "StyleColorsImport",
    // ===Props passed to component
    props: {},
    // ===Components used by this component
    components: {
      vueDropzone: vue2Dropzone
    },
    // ====component Data properties
    data(){
        return{
          dropzoneOptions: {
            url: '',
            thumbnailWidth: 150,
            maxFilesize: 5.0,
            headers: {
              // Accept : "text/csv; charset=utf-8",
              // "Content-Type": "text/csv; charset=utf-8",
              "Access-Control-Allow-Origin": "*"
            },
          },
          loading: false
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      this.dropzoneOptions.url = this.$apiAdress + '/api/uploadStyleColors?token=' + localStorage.getItem('api_token')
      // var that = this
      // setTimeout(function () {
      //   console.log('ready')
      //   var input = document.getElementById('dealCsv');
      //   input.addEventListener('change', function() {
      //     console.log('ooo change')
      //     console.log(this.files)
      //     if (this.files && this.files[0]) {

      //         var myFile = this.files[0];
      //         var reader = new FileReader();
              
      //         reader.addEventListener('load', function (e) {
      //             console.log('loading')
      //             let csvdata = e.target.result; 
      //             // that.csvData = csvdata
      //             that.getParsecsvdata(csvdata)// calling function for parse csv data 
                  
      //         });
              
      //         reader.readAsBinaryString(myFile);
      //     }
      //   });
      // }, 1000)
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
